import axios from "axios";
import Vue from "vue";

export default {
  namespaced: true,

  state: {
    all: [],
  },

  actions: {
    index({commit}) {
      return axios.get(process.env.VUE_APP_API_URL + 'extra-settings')
          .then(({data}) => {
            const items = data.filter((item) => item.closed_frame);

            commit('setItems', items);
          });
    },
  },

  getters: {
    getAll(state) {
      return state.all;
    },
    getBuildArray(state, getters, rootState) {
      let result = [];

      state.all.forEach((option) => {
        if (option.selected) {
          result.push(option.id);
        }
      });

      return result;
    },

    getPriceArray(state) {
      let result = [];

      state.all.forEach((option) => {
        if (option.selected) {
          result.push({'name': option.name.nl, 'price': option.price});
        }
      });

      return result;
    }
  },

  mutations: {
    setItems(state, array) {
      state.all = array;
    },

    setSelected(state, {index, bool}) {
      state.all[index].selected = bool;
    },

    setSelect(state, array) {
      state.all = array;
    },

    toggleSelected(state, option) {
      Vue.set(option, 'selected', !option.selected);
    },
  },
}